import React from 'react';
import { Box, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { GREY1 } from 'constants/colors';


const useStyles = makeStyles((theme) =>
  createStyles({
    Wrapper: {
        width: 544,
        height: 344,
        display: 'grid',
        gridTemplateRows: '1fr auto',
        justifyItems: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 32,
        marginLeft: -40,
      
        [theme.breakpoints.down(1280)]: {
          width: '100%',
          maxWidth: 600,
          height: 'auto',
          marginLeft: 0,
          gap: theme.spacing(3),
          minHeight: 300,
        },
      
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
          padding: theme.spacing(0, 2),
          gap: theme.spacing(2),
          minHeight: 'auto',
        },
      },
      
      LogoContainer: {
        width: 500,
        height: 282,
        opacity: 1,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'stretch',
      
        [theme.breakpoints.down(1280)]: {
          width: '100%',
          height: 'auto',
          aspectRatio: '500 / 282',
          minHeight: 200,
        },
      
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          height: 'auto',
          aspectRatio: 'auto',
          minHeight: 0,
        },
    },
    LogoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    Description: {
        fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
        fontWeight: 500,
        fontSize: 24,
        lineHeight: '125%',
        letterSpacing:0,
        color: GREY1,
        [theme.breakpoints.down(1280)]: {
            fontSize: 22,
        },
    },
  })
);




export const ShowcaseLogo: React.FC = () => {
    const classes = useStyles();
    return (
        <Box className={classes.Wrapper}>
            <Box className={classes.LogoContainer}>
                <Box
                    component="img"
                    src="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641cdd80d5c12478bb86e0cd_Company%20Logos.png"
                    className={classes.LogoImage}
                    loading='lazy'
                    srcSet="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641cdd80d5c12478bb86e0cd_Company%20Logos-p-500.png 500w, https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641cdd80d5c12478bb86e0cd_Company%20Logos-p-800.png 800w, https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641cdd80d5c12478bb86e0cd_Company%20Logos.png 1000w"
                />
            </Box>
            <Typography variant="h3">
                認識在這些公司工作的朋友
            </Typography>
        </Box>
    )
}
